var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('TopNewsBanner'),_c('ItemsGrid',{attrs:{"data":_vm.items,"isLoading":_vm.isLoading,"types":_vm.types,"component":_vm.component},on:{"typeChange":_vm.changeType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }